import * as S from './styles';
import Workspace from 'components/Workspace';
import WorkspaceMobile from 'components/WorkspaceMobile';
import FrameInspector from 'components/FrameInspector';
import { RootReducer } from 'redux/reducers';
import { useSelector, shallowEqual } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import FrameGallery from 'components/FrameGallery';

interface SceneLayoutProps {
	frameId: string | null;
}

const SceneLayout = ({ frameId }: SceneLayoutProps) => {
	const { isMobile } = useSelector((r: RootReducer) => {
		return {
			isMobile: selectIsMobile(r.mode),
		};
	}, shallowEqual);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return isMobile ? (
		<S.Base>{frameId ? <FrameGallery frameId={frameId} /> : <WorkspaceMobile />}</S.Base>
	) : (
		<S.Base>
			<S.Application>
				{frameId ? <FrameInspector frameId={frameId} /> : <Workspace />}
			</S.Application>
		</S.Base>
	);
};

export default SceneLayout;
